import { atom } from "recoil";

export const hoverStatusState = atom({
  key: "hoverStatusState",
  default: false
});
